


























import Vue from 'vue'
import Spinner from 'vue-simple-spinner';
import axios, { AxiosResponse } from 'axios'
export default Vue.extend({
  name: 'EditorBottomTiles',
  components: { Spinner },
  props: {
    feedData: {
      type: Object,
      default: null
    },
    publicID: {
      type: String,
      default: ''
    },
    privateID: {
      type: String,
      default: null
    },
    podpastSettings: {
      type: Object,
      default: null
    },
    sourceData: {
      type: Object,
      default: null
    }
  },
  data(): {
    inProgress: boolean,
    emailAddress: string
  } {
    return {
      inProgress: false,
      emailAddress: ''
    }
  },
  methods: {
    sendMeAnEmail() {
      this.inProgress = true
      axios.post('https://api.podspast.com/sendEmail', {
        emailAddress: this.emailAddress
      }, {
        withCredentials: false
      })
        .then((resp: AxiosResponse) => {
          if (resp.data.successResponse) {
            alert('We\'ve sent you an email with the details.')
          }
          this.inProgress = false
        })
        .catch((error: Error) => {
          this.inProgress = false
          alert('Error occurred while sending the email, sorry! Save the link to this page'
            + '- it will bring you back to this page if you ever want to edit your podpast.')
        })
    }
  }
})
